import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {

  },
  actions: {
    async fetchCards(_, params) {
      return axiosIns.get('vouchers/cards', {
        params,
      }).then(res => res.data.data)
    },
    async createCards(_, batch) {
      return axiosIns.post('vouchers/cards/batch', batch)
    },
    async updateCard(_, { id, expiryDate, active }) {
      return axiosIns.patch(`vouchers/cards/${id}`, { expiryDate, active })
    },
  },
}
